import { createFileRoute } from '@tanstack/react-router'
import { OrganizationBillingPeriods } from '@/pages/OrganizationBillingPeriods'

export const Route = createFileRoute(
  '/_authenticated/organizations/$id/credits/billing-periods'
)({
  component: OrganizationBillingPeriods,
})
